import React, { useEffect } from 'react';
import { Grid, Typography, Button, useTheme } from '@mui/material';
import RoomDropdown from './RoomDropdown';

const RoomInfoContainer = ({
  passengersValue,
  setRoomInfo,
  quantity,
  setQuantity,
  hanleListo,
}) => {
  const theme = useTheme();

  let rooms = quantity;

  if (!quantity?.length) {
    rooms = [
      {
        id: crypto.randomUUID(),
        n: 1,
        adt: 2,
        men: [],
      },
    ];
  }

  useEffect(() => {
    const passengers = rooms.flatMap(room => {
      const adults = Array.from({ length: room.adt }, () => ({
        id_passenger_type: 1,
        sequence: room.n,
      }));

      const getPassengerType = age => {
        if (age <= 1) {
          return 3; // bebé
        }
        if (age <= 17) {
          return 2; // niño
        }
        return 1; // adulto
      };

      const children = room.men.map(m => ({
        id_passenger_type: getPassengerType(m.age),
        age: m.age,
        sequence: room.n,
      }));
      return [...adults, ...children];
    });

    const bookingInfo = passengers.reduce(
      (acc, p) => {
        acc.total_passengers++;
        if (p.sequence > acc.totalRooms) acc.totalRooms = p.sequence;
        return acc;
      },
      { total_passengers: 0, totalRooms: 0 }
    );

    passengersValue(passengers);
    setRoomInfo(bookingInfo);
  }, [rooms]);

  const addRoom = () =>
    setQuantity([
      ...rooms,
      {
        id: crypto.randomUUID(),
        n: rooms.length + 1,
        adt: 2,
        men: [],
      },
    ]);

  const editRoom = updatedRoom =>
    setQuantity(rooms.map(r => (r.id === updatedRoom.id ? updatedRoom : r)));

  const deleteRoom = roomId =>
    setQuantity(
      rooms.filter(r => r.id !== roomId).map((r, i) => ({ ...r, n: i + 1 }))
    );

  return (
    <Grid container justifyContent="center">
      {rooms.map((room, idx) => (
        <RoomDropdown
          key={room.id}
          roomInfo={room}
          updateRoom={editRoom}
          buttonHandler={deleteRoom}
          deleteDisable={rooms.length > 1}
          showDivider={idx !== rooms.length - 1}
        />
      ))}
      {/* Botón añadir habitación */}
      {rooms.length <= 3 && (
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography
            sx={{
              color: 'tertiary.main',
              cursor: 'pointer',
              textDecoration: 'underline',
              pl: 2,
            }}
            onClick={addRoom}
          >
            Añadir habitación
          </Typography>
        </Grid>
      )}

      {/* Botón aplicar */}
      <Grid container justifyContent="center" sx={{ mt: 2 }}>
        <Button
          variant="contained"
          fullWidth
          onClick={hanleListo}
          sx={{
            fontWeight: 600,
            bgcolor: theme.primary,
            color: theme.text1,
            '&:hover': {
              bgcolor: theme.primary,
              color: theme.text1,
              opacity: 0.9,
            },
          }}
        >
          Aplicar
        </Button>
      </Grid>
    </Grid>
  );
};

export default RoomInfoContainer;
